
/**
 * Dependencies:
 *  - jQuery
 */

const Forms = {

    init: () => {
        jQuery('.radio-btn input').change((event) => {
            const radioButton = event.currentTarget;
            const fieldName = radioButton.name;
            jQuery('input[name=' + fieldName + ']').parent().removeClass('selected');
            jQuery(radioButton).parent().addClass('selected');
        });


    }

}


export default Forms;
